// extracted by mini-css-extract-plugin
export default {"select":"Form-Select__select--xZ5ig","noBorders":"Form-Select__noBorders--wS4wQ","dropdown":"Form-Select__dropdown--inmw0","fullWidth":"Form-Select__fullWidth--RjzXu"};